module.exports = __webpack_public_path__ + "img/settingsGear_p.9e483fcf.svg";